export enum BaseFilterEnum {
  Query_Filter = "search",
  Sort_By = "sortBy",
  Sort_Desc = "sortByDesc",
  Limit = "limit",
  Offset = "offset"
}
